import { SET_VEHICLELIST } from '../actions';

const vehiclelist = (state = [], action) => {
  switch (action.type) {
	case SET_VEHICLELIST:
      return [...action.value];  
    default: return state;
  }
}

export default vehiclelist;
